// Pattern presets for different rhythmic patterns
export const PATTERN_PRESETS = {
  empty: {
    name: "Empty",
    description: "Clear pattern",
    pattern: [] as number[], // No active steps
  },
  fourOnFloor: {
    name: "Four on Floor",
    description: "Classic house beat",
    pattern: [0, 4, 8, 12], // Every 4th step
  },
  backbeat: {
    name: "Backbeat",
    description: "2 and 4 emphasis",
    pattern: [4, 12], // Steps 5 and 13 (beats 2 and 4)
  },
  offbeat: {
    name: "Offbeat",
    description: "Syncopated rhythm",
    pattern: [2, 6, 10, 14], // Off-beat steps
  },
  triplet: {
    name: "Triplet",
    description: "Triplet feel",
    pattern: [0, 3, 6, 9, 12, 15], // Every 3rd step
  },
  breakbeat: {
    name: "Breakbeat",
    description: "Complex breakbeat pattern",
    pattern: [0, 2, 6, 8, 10, 14], // Irregular pattern
  },
  minimal: {
    name: "Minimal",
    description: "Sparse minimal pattern",
    pattern: [0, 7], // Very sparse
  },
  dense: {
    name: "Dense",
    description: "Dense pattern",
    pattern: [0, 1, 3, 4, 6, 7, 9, 10, 12, 13, 15], // Many active steps
  },
  swing: {
    name: "Swing",
    description: "Swing rhythm",
    pattern: [0, 2, 4, 6, 8, 10, 12, 14], // Every other step
  },
  euclidean5: {
    name: "Euclidean 5",
    description: "5 hits distributed evenly",
    pattern: [0, 3, 6, 9, 13], // Euclidean rhythm with 5 hits
  },
  euclidean7: {
    name: "Euclidean 7",
    description: "7 hits distributed evenly",
    pattern: [0, 2, 4, 7, 9, 11, 14], // Euclidean rhythm with 7 hits
  },
};
